import React, { useEffect, useState } from 'react';
// import ModalFormSchedule from '../../components/forms/schedule/modal.form.schedule'
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';
import ModalMessage from '../../components/widgets/modalMessage';
import { useNavigate } from "react-router-dom";
import ModalInfoSchedule from '../../components/forms/schedule/modal.form.schedule';

function ListScheduleTech() {
  const navigate = useNavigate();
  const [scheduleSelect, selectClientSelect] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [msgGet ,setMsgGet] = useState('');
  const [schedules,setSchedule] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getSchedule()
  }, []);

  const assignSchedule = (id) => {
    setShowModal(true);
    selectClientSelect(id);
  };

  const editButton = (row) => {
    return (
      <Row>
        <Col>
          <ModalInfoSchedule 
          scheduleSelect={row.id}  
          title='Informacion Agenda'
          button_text='Ver Info'
          button_variant='outline-primary' />
        </Col>
        <Col>
          <Button onClick={()=> assignSchedule (row.id)} variant="outline-primary" >Iniciar Atencion</Button>
        </Col>
      </Row>
    );
  };

  const createInspection = async ()=>{
    const respoPeritaje = await get('/schedule/inspection/'+scheduleSelect, {});
    setShowModal(false);
    if(respoPeritaje.success){
      const url = `/modifyInspection/${respoPeritaje.data.encryptid}`
      navigate(url);
    }else{
      setAlert({
        show: true,
        message:respoPeritaje.message ,
        type: 'danger'
      })
    }
  }

  const getSchedule = async()=>{
    const responseSchedule = await get('/schedule/myschedule/',{})
    if(responseSchedule.success){
      setSchedule(responseSchedule.data);
    }else{
      setMsgGet(responseSchedule.message)
    }       
  }


  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalMessage
        title={'Advertencia'}
        text={`Desea iniciar la atencion de esta agenda?`}
        showProps={showModal}
        funcAccept={createInspection}
        funcClose={()=>setShowModal(false)}
      />
      <ListTables
        data={schedules}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListScheduleTech;
